const INSTRUCTIONS_SERVICE = 'https://instructions.documents.cimpress.io';
export function getInstructionsServiceUrl() {
  return "".concat(INSTRUCTIONS_SERVICE, "/v3/instructions:preview");
}
export function getItemInstructionsServiceUrl() {
  return "".concat(INSTRUCTIONS_SERVICE, "/v3/instructions:item");
}
export function buildInstructionsUrl(_ref) {
  let {
    cimDocUrl,
    surfaceOrdinals,
    ignoreProjection,
    instructionsServiceUrl = getInstructionsServiceUrl()
  } = _ref;
  const url = new URL(instructionsServiceUrl);
  url.searchParams.set('documentUri', cimDocUrl);
  if (surfaceOrdinals) {
    url.searchParams.set('surfaceOrdinals', "".concat(surfaceOrdinals));
  }
  if (ignoreProjection) {
    url.searchParams.set('ignoreProjection', "".concat(ignoreProjection));
  }
  return url.toString();
}